"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../Icon"));
var styled_components_1 = __importStar(require("../../Themes/styled-components"));
var OptionIcon = styled_components_1.default('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n  min-width: ", ";\n  margin-right: ", ";\n  ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n  min-width: ", ";\n  margin-right: ", ";\n  ",
    ";\n"])), function (_a) {
    var iconSize = _a.iconSize;
    return iconSize + "px";
}, function (_a) {
    var iconSize = _a.iconSize;
    return iconSize + "px";
}, function (_a) {
    var iconSize = _a.iconSize;
    return iconSize + "px";
}, function (_a) {
    var iconSize = _a.iconSize;
    return polished_1.em(iconSize / 2);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: not-allowed;\n      opacity: 0.5;\n    "], ["\n      cursor: not-allowed;\n      opacity: 0.5;\n    "])));
});
var Label = styled_components_1.default('span')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: ", ";\n  ", ";\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: ", ";\n  ",
    ";\n"])), function (_a) {
    var labelSize = _a.labelSize;
    return polished_1.rem(labelSize);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      cursor: not-allowed;\n      opacity: 0.5;\n    "], ["\n      cursor: not-allowed;\n      opacity: 0.5;\n    "])));
});
var DEFAULT_ICON_SIZE = 14;
var DEFAULT_LABEL_SIZE = 12;
function LabelIcon(props) {
    var icon = props.icon, iconColor = props.iconColor, iconSize = props.iconSize, disabled = props.disabled;
    if (typeof icon === 'string') {
        return (React.createElement(OptionIcon, { iconSize: iconSize || DEFAULT_ICON_SIZE, disabled: disabled, "data-testid": "TheSelect-LabelIconString" },
            React.createElement(Icon_1.default, { name: icon, size: iconSize || DEFAULT_ICON_SIZE, color: iconColor })));
    }
    if (typeof icon === 'object') {
        return (React.createElement(OptionIcon, { iconSize: iconSize || DEFAULT_ICON_SIZE, disabled: disabled, "data-testid": "TheSelect-LabelIconObject" }, icon));
    }
    return null;
}
exports.default = (function (props) {
    var label = props.label, labelSize = props.labelSize, disabled = props.disabled;
    return (React.createElement(React.Fragment, null,
        React.createElement(LabelIcon, __assign({}, props)),
        React.createElement(Label, { labelSize: labelSize || DEFAULT_LABEL_SIZE, disabled: disabled }, label)));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
